<template>
	<v-tooltip v-if="day.isHoliday()" bottom class="holiday-tip">
		<template v-slot:activator="{ on, attrs }">
			<div class="gb-cell gb-day" tile v-bind:class="styleDayWeekday" v-bind:style="styleUnitDay" v-on="on">
				<span>{{ weekName }}</span>
			</div>
		</template>
		<span>{{ this.day.getHolidayName() }}</span>
	</v-tooltip>
	<div v-else class="gb-cell gb-day" tile v-bind:class="styleDayWeekday" v-bind:style="styleUnitDay">
		<span>{{ weekName }}</span>
	</div>
</template>
<script>
import{WEEKS_NAMES} from '../data/Const'; 
export default {
	name: 'GBDayWeekDay',
	props:["day"],
	computed: {
		styleDayWeekday: function() {
			
			let classes = new Array();
			if (this.day.isHoliday()){
				classes.push("lighten-3","primary");
			} else {
				classes.push("lighten-3","primary");
			}
			
			if ((this.day.weekDayNum == 0) || this.day.isHoliday()){
				classes.push("red--text");
			} else if (this.day.weekDayNum == 6) {
				classes.push("blue--text text--darken-3");
			} else {
				classes.push("white--text");
			}
			return classes;
		},
		styleUnitDay: function() {
			return {
				width: (this.$store.getters.unitWidth) + 'px',
			};
		},
		weekName: function() {
			return WEEKS_NAMES[this.day.weekDayNum];
		},
	},
}
</script>
<style>
.holiday-tip {
	z-index:99;
}
</style>
